import React, { useState } from "react";
import { SearchIcon, ShoppingCartIcon } from "lucide-react";
import { useCart } from "../contexts/CartContext";
import { CartDrawer } from "./CartDrawer";
import { GlitterSparkles } from "./GlitterSparkles";
import { SearchForm } from "./SearchForm";
type SiteHeaderProps = {
  onHome: () => void;
  onShopAll: () => void;
  onContact: () => void;
  onSearch: (query: string) => void;
};
const linkClass = "whitespace-nowrap text-white/80 transition-colors duration-150 ease-out hover:text-[#35dceb] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#35dceb]";
export function SiteHeader({
  onHome,
  onShopAll,
  onContact,
  onSearch
}: SiteHeaderProps) {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const {
    itemCount,
    openCart
  } = useCart();
  const handleSearch = (query: string) => {
    setIsSearchOpen(false);
    onSearch(query);
  };
  return <header className="relative z-30 flex w-full items-center justify-between gap-3 bg-[#10070f] px-4 py-3 text-white sm:px-8 sm:py-3.5" data-id="element-366" data-mp="2bbz2zkok7twg">
      <GlitterSparkles data-id="element-367" data-mp="2eiwsjgj6j8e1" />
      <button type="button" onClick={onHome} style={{
      fontFamily: "'Kaushan Script', cursive",
      backgroundImage: "linear-gradient(90deg, #ff3aa2 0%, #a855f7 50%, #2dd4bf 100%)",
      WebkitBackgroundClip: "text",
      backgroundClip: "text",
      color: "transparent"
    }} className="relative shrink-0 py-0.5 pr-1 text-xl leading-none transition-opacity duration-150 ease-out hover:opacity-80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#35dceb] sm:text-2xl" data-id="element-368" data-mp="2ei3vx8dxpz9m">
        Pickens Passion
      </button>
      <nav aria-label="Site" className="relative flex min-w-0 items-center gap-4 text-[11px] font-semibold uppercase tracking-[0.14em] sm:gap-7 sm:text-sm" data-id="element-369" data-mp="25jryonikc387">
        {isSearchOpen ? <div className="w-44 sm:w-64" data-id="element-370" data-mp="1d0ml8mk0yu4h">
            <SearchForm size="compact" autoFocus onSearch={handleSearch} onCancel={() => setIsSearchOpen(false)} data-id="element-371" data-mp="1czl17sl16xam" />
          </div> : <button type="button" onClick={() => setIsSearchOpen(true)} aria-label="Search products" className="inline-flex h-7 w-7 items-center justify-center text-white/80 transition-colors duration-150 ease-out hover:text-[#35dceb] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#35dceb]" data-id="element-372" data-mp="1013pwr7w6nbl">
            <SearchIcon size={18} aria-hidden="true" data-id="element-373" data-mp="h4c68gofu670" />
          </button>}
        <button type="button" onClick={onShopAll} className={linkClass} data-id="element-374" data-mp="w0tkbfo0hyx9">
          Shop All
        </button>
        <button type="button" onClick={onContact} className={`${linkClass} ${isSearchOpen ? "hidden sm:inline" : ""}`} data-id="element-375" data-mp="r0fabs2uoewl">
          Contact Us
        </button>
        <button type="button" onClick={openCart} aria-label={itemCount > 0 ? `Open cart, ${itemCount} ${itemCount === 1 ? "item" : "items"}` : "Open cart"} className="relative inline-flex h-7 w-7 shrink-0 items-center justify-center text-white/80 transition-colors duration-150 ease-out hover:text-[#35dceb] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#35dceb]" data-id="element-376" data-mp="22gm2i5kqv2hg">
          <ShoppingCartIcon size={19} aria-hidden="true" data-id="element-377" data-mp="251borv2x7jck" />
          {itemCount > 0 && <span className="absolute -right-2 -top-1.5 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-[#ff3aa2] px-1 text-[10px] font-bold leading-none tracking-normal text-white" data-id="element-378" data-mp="2sr618bjbv5wa">
              {itemCount > 99 ? "99+" : itemCount}
            </span>}
        </button>
      </nav>
      <CartDrawer onShopAll={onShopAll} data-id="element-379" data-mp="2ny36w16q7sf1" />
    </header>;
}